import React from "react";
import {
  GSActionBar,
  defaultBorders,
  defaultGapping,
  defaultLayouts,
  defaultPadding,
  defaultTypography,
  golfstatusColors,
} from "golfstatus_react_components";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { SCOPE_SUBTITLES } from "../../../helpers/CustomFieldResponses";
import TournamentOrderFormResponseAnswerItem from "./tournament-order-form-response-answer-item";

const cardStyle = {
  ...defaultLayouts.vStack,
  ...defaultLayouts.fullWidth,
  ...defaultGapping.largeGap,
  ...defaultPadding.xLargePad,
  ...defaultBorders.mediumLargeBorderRadius,
  background: golfstatusColors.grey100,
};

const questionCardStyle = {
  ...defaultLayouts.vStack,
  ...defaultLayouts.fullWidth,
  ...defaultGapping.mediumGap,
  ...defaultPadding.largePad,
  ...defaultBorders.mediumLargeBorderRadius,
  background: golfstatusColors.white,
};

const answersStyle = {
  ...defaultLayouts.vStack,
  ...defaultLayouts.fullWidth,
  ...defaultGapping.mediumGap,
};

const headerTitleStyle = {
  ...defaultLayouts.vStack,
};

const formNameStyle = {
  ...defaultTypography.mediumBoldBody,
  whiteSpace: "normal",
};

const subtitleStyle = {
  ...defaultTypography.bodyRegular,
  color: golfstatusColors.grey800,
  opacity: 0.7,
};

const TournamentOrderFormResponseCard = (props) => {
  const {
    form,
    viewAction,
    onRemove,
    isRemoveDisabled,
    onSaved,
    onUnsaved,
    editingKey,
    onEdit,
    commitRef,
  } = props;

  const getHeader = () => (
    <div style={headerTitleStyle}>
      <div style={formNameStyle}>{form?.form?.name}</div>
      <div style={subtitleStyle}>{SCOPE_SUBTITLES[form?.scope]}</div>
    </div>
  );

  const getHeaderActions = () => {
    const actions = [];
    if (viewAction) {
      actions.push({
        buttonTitle: viewAction.title,
        actionIcon: viewAction.buttonIcon,
        actionClick: viewAction.onClick,
        type: "white no-wrap mobile-icon",
      });
    }
    if (onRemove) {
      actions.push({
        actionIcon: faTrash,
        actionClick: () => onRemove(form),
        type: "white no-wrap",
        isDisabled: isRemoveDisabled,
      });
    }
    return actions;
  };

  const getQuestionCard = (question) => (
    <div style={questionCardStyle} key={question?.question?.id}>
      <div style={{ ...defaultTypography.body }}>
        {question?.question?.name}
        {question?.question?.required && " *"}
      </div>
      <div style={answersStyle}>
        {(question?.responses ?? []).map((answer) => (
          <TournamentOrderFormResponseAnswerItem
            key={`${question?.question?.id}-${answer?.record?.id}`}
            record={answer?.record}
            response={answer?.response}
            question={question?.question}
            editingKey={editingKey}
            onEdit={onEdit}
            commitRef={commitRef}
            onSaved={onSaved}
            onUnsaved={onUnsaved}
          />
        ))}
      </div>
    </div>
  );

  return (
    <tournament-order-form-response-card style={{ display: "block" }}>
      <div style={cardStyle}>
        <GSActionBar header={getHeader()} pageActions={getHeaderActions()} />
        {(form?.questions ?? []).map((question) => getQuestionCard(question))}
      </div>
    </tournament-order-form-response-card>
  );
};

export default TournamentOrderFormResponseCard;
